import React from 'react';
import s from './s.module.less';

import Zoom from './imgs/zoom.png';
import LeftIcon from './imgs/left.png';
import { Modal } from 'antd';
import ZoomMeetingLandingPage from './ZoomMeetingLandingPage';
import commonS from 'styles/common.module.less';
//https://www.figma.com/design/w4vpLJZeMLx9XzMg0c71Dm/Financial---Settings?node-id=8104-79126&m=dev
//a. User has not applied Klarity Pay Later yet
//b. User's application is being processed
//c. User’s application is under review
//d. After the user’s application is approved
//e. If a user has clicked ‘View your offers’ & and opened the modal
//f. If the user’s application is declined


type Props = {
    onClose: () => void;
};

const ZoomVideoVisitsBanner = (props: Props) => {
    const { onClose } = props;
    const [showLearnMore, setShowLearnMore] = React.useState(false);
    return (
        <div className={s.wrap}>
            <div className={s.left}>
                <img src={LeftIcon} alt="left" className={s.img} />
            </div>
            <div className={s.center}>
                <div className={s.title}>🔔 Klarity now supports secure <img src={Zoom} /> video visits — free to use</div>
                <div className={s.des}>A secure video link is automatically created for both your self-scheduled and Klarity-booked appointments, letting you start video visits directly from Klarity dashboard.</div>
            </div>
            <div className={s.right}>
                <div
                    onClick={async () => {
                        setShowLearnMore(true);
                    }}
                    className={s.btn}
                >
                    Learn more
                </div>
                <span
                    onClick={() => {
                        onClose?.();
                    }}
                    className={s.close}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                        <path d="M1 13L13 1M1 1L13 13" stroke="#4B5563" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </span>
            </div>
            <Modal
                open={showLearnMore}
                onCancel={() => {
                    setShowLearnMore(false);
                }}
                footer={null}
                width="1166px"
                className={commonS.modalFixHeightWithoutPaddingWrap}
                title={<div>Learn more about secure <img className={s.modalTitleIcon} src={Zoom} /> video visits</div>}
            >
                <ZoomMeetingLandingPage 
                    onGetStarted={() => {}}
                    onClose={() => {
                        setShowLearnMore(false);
                    }}
                />
            </Modal>
        </div>
    );
};

export default ZoomVideoVisitsBanner;
